import { lazy, Suspense } from 'react'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

const LazyBillApprovalListView = lazy(() =>
  import('@webapp/modules/accounts-payable/feature-sets/BillApprovalListView').then(
    ({ BillApprovalListView }) => ({
      default: BillApprovalListView,
    })
  )
)

export const BillApprovalsPage = () => {
  const intl = useProcurifyIntl()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.billApprovalsPageTitle)}
      breadcrumbs={[
        {
          name: intl.formatMessage(messages.billApprovalsPageTitle),
        },
      ]}
    >
      <Suspense fallback={null}>
        <LazyBillApprovalListView />
      </Suspense>
    </Page>
  )
}
